import { WorkflowStatus } from "../../api/models/workflow-status";
import { hasApproveAction } from "./workflowActions";

export { APPROVE_ACTIONS } from "./workflowActions";

/**
 * IDS-5755: single source of truth for the 7 workflow-status categories used both by the outline
 * status filter and by the pre-existing row/status icon classifiers.
 *
 * `getWorkflowCategory` replicates EXACTLY the classification logic that used to be duplicated in:
 *  - TreeItemRowUtils.ts#iconCertification
 *  - DocumentPartTreeUtils.ts#checkNextApprover (APPROVE_ACTIONS only)
 *  - OutlineSearchResultRow.tsx#getWorkflowIconClass
 *
 * See docs/ids-5755-outline-filter/04-data-model.md §1-2 for the authoritative category table.
 */
export enum OutlineFilterStatus {
  NOT_RELEVANT = "NOT_RELEVANT",
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  TO_BE_APPROVED = "TO_BE_APPROVED",
  SUBMITTED = "SUBMITTED",
  REJECTED = "REJECTED",
}

/** Actions (any approval level) that mean the current user can approve the pending node. */

/**
 * Classifies a WorkflowStatus into one of the 7 OutlineFilterStatus categories.
 *
 * The mapping is evaluated top to bottom; the "not significant" check takes precedence over the
 * status code, matching the original `iconCertification` / `getWorkflowIconClass` ordering.
 */
export function getWorkflowCategory(status: WorkflowStatus): OutlineFilterStatus {
  if (!(status?.isSignificant || status?.significant)) {
    return OutlineFilterStatus.NOT_RELEVANT;
  }
  switch (status?.workflowStatusCode) {
    case "20":
      return OutlineFilterStatus.IN_PROGRESS;
    case "30":
    case "31":
    case "32":
    case "33":
    case "34": {
      return hasApproveAction(status.actions)
        ? OutlineFilterStatus.TO_BE_APPROVED
        : OutlineFilterStatus.PENDING_APPROVAL;
    }
    case "40":
      return OutlineFilterStatus.REJECTED;
    case "50":
      return OutlineFilterStatus.SUBMITTED;
    default:
      return OutlineFilterStatus.NOT_STARTED;
  }
}
